<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">trolley</span>
        <span class="soc-panel-h">{{'PURCHASE_ORDER.PURCHASE_ORDER_DETAILS' | translate}}</span>
        <span [ngClass]="purchaseOrder.statusType == InventoryActionStatus.Pending ? 'soc-pill-lbl soc-cyan-pill-outline' : 'soc-pill-lbl soc-neutral-30-pill-outline'">{{purchaseOrder.statusType}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <div class="pos-actions-wrapper">
        <div class="soc-display-field-wrapper">
            <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.SUPPLIER' | translate}}</label>
            <div class="soc-display-field"> <span class="soc-display-text">{{purchaseOrder.supplier?.name}}</span></div>
        </div>
        <div class="soc-display-field-wrapper">
            <label class="soc-input-lbl w-100 text-start">{{'PURCHASE_ORDER.ISSUE_DATE' | translate}}</label>
            <div class="soc-display-field"> <span class="soc-display-text">{{purchaseOrder.issuedOn | tzConvert: timezoneOffset:'DD MMM YYYY'}}</span></div>
        </div>
    </div>
    <p-table *ngIf="purchaseOrder.lineItems" class="soc-borderless-table" [value]="purchaseOrder.lineItems" scrollHeight="calc(100vh - 462px)" [scrollable]="true" [virtualScroll]="true">
        <ng-template pTemplate="header">
            <tr> 
                <th>{{'INVENTORY_ITEM.CODE' | translate}}</th> 
                <th>{{'INVENTORY_ITEM.ITEM_NAME' | translate}}</th> 
                <th>{{'INVENTORY_ITEM.QUANTITY' | translate}}</th> 
                <th></th>
            </tr> 
        </ng-template>
        <ng-template pTemplate="body" let-item  let-rowIndex="rowIndex">            
            <tr>
                <td class="secondary-td">{{item.stockItem.code}}</td>
                <td>{{item.stockItem.name}}</td>
                <td>{{item.quantityOrdered + " " + (item.stockItem.unitType | unitShortener | lowercase)}}</td>
                <td></td>
            </tr> 
        </ng-template>
    </p-table>
    <hr class="soc-panel-line"/>
    <div class="d-flex align-items-center justify-content-between">
        <button class="soc-secondary-grey-btn" (click)="navigateToMain()" ><span class="material-icons-round">arrow_back</span>{{'BACK' | translate}}</button>
        <button *ngIf="purchaseOrder.statusType == InventoryActionStatus.Pending" class="soc-basic-orange-btn" (click)="cancelOrder()">{{'PURCHASE_ORDER.CANCEL_ORDER' | translate}}</button>
    </div>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>